import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './App/rootReducer';
import sagas from './sagas';

const enhancers = [];
const middleware = [];

if (process.env.NODE_ENV === 'development') {
  // Additional logging in non-production environments.
  middleware.push(createLogger());

  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension());
  }
}

const sagaMiddleware = createSagaMiddleware();
middleware.push(sagaMiddleware);

// const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

export default createStore(rootReducer, applyMiddleware(...middleware));

sagaMiddleware.run(sagas);


// WEBPACK FOOTER //
// ./src/store.js